import { BooleanParam, useQueryParams } from 'use-query-params'

export const useIsEmbeddedInMobileApp = () => {
  const [{ mobileApp }] = useQueryParams({ mobileApp: BooleanParam })
  return mobileApp || typeof ReactNativeWebView !== 'undefined'
}
